module.exports = __webpack_public_path__ + "static/media/tinyTomatoTimerLogo.b3da486f.svg";